import React from "react"
import { Link } from "gatsby"
import Image from "../image"

// Style
import "./Footer.scss"

const Footer = () => {
  return (
    <footer id="footer" className="footer-container">
      <div className="content-wrapper">
        <h1>Kontakt</h1>
        <p>
          Wir konnten Ihr Interesse wecken? Sie Haben Fragen oder Anregungen?
        </p>
        <p>
          Gerne sind wir für Sie da, nutzen Sie einfach die Möglichkeit uns
          unter der angegebenen E-Mail-Adresse{" "}
          <a href="mailto:direktion@migus.de">direktion@migus.de</a> zu
          kontaktieren, wir werden Ihre Anfrage schnellst möglich bearbeiten und
          uns bei Ihnen zurück melden.
        </p>
        <div className="fb-link">
          <p>Besuchen Sie uns auch auf Facebook</p>
          <a
            href="https://www.facebook.com/Eis-Charlie-159432034168973/"
            target="_blank"
          >
            <Image imgName="facebook" />
          </a>
        </div>
        <p className="fourth-div_footer_c">
          Copyright © 2020 Eiswagen Hamburg | Eis Charlie |{" "}
          <Link to="/datenschutz" target="_blank" className="footer-a">
            Datenschutz
          </Link>
          I
          <Link to="/impressum" target="_blank" className="footer-a">
            Impressum
          </Link>
          I
          <a
            className="footer-a"
            href="https://kuppel-hamburg.de/wp-content/themes/kuppel/agb.pdf"
            target="_blank"
          >
            AGB
          </a>
        </p>
      </div>
    </footer>
  )
}

export default Footer
